import getConfig from "next/config.js";
import RecallApiConfig from "../recallsConfig.js";

// Using local host from client request state as I'm having issues due to referrers during testing. Having it use the client state allows me to spoof my referrer for CMS requests on both the client and server using ACC, whilst also being able to make local requests to Next API URLs on my local machine. 
//
// We may need to add another base path environment var to allow for this type of override, if we want to stick to explicit base paths in our links. 
const host = typeof window !== "undefined" ?
	window.location.protocol + "//" + window.location.host :
	getConfig().domain;

// I believe we should move all client requests to proxies like this moving forward. We curently expose a lot of database and API URLs on Honda due to doing so much on the client.
export default {
	async getCarsRecalls(vinNumber) {
		try {
			const url = new URL(`${host}/api/recalls/check`);

			url.search = new URLSearchParams({ vin: vinNumber }).toString();

			const result = await fetch(url);

			const json = await result.json(); // { messages: [{ message: string }]} || { error: string } // in case of none found.

			return json;
		} catch (err) {
			if (err instanceof Error) {
				console.error(err);
			}
		};

		return null;
	},
};